<template>
  <div id="footer" class="footer">
    <div class="copyright">
      <img class="logo" :src="getLogoImgUrl()" alt=""/>
      <span class="version">Version: {{ version }}</span>
    </div>
  </div>
</template>

<script>
import Base from '@/mixins/base'

export default {
  name: 'footerComponent',
  mixins: [Base],
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  methods: {}
}
</script>

<style scoped></style>
